// -------------------------------------------------------------------- constants --------------------------------------------------------------------
import jMoment from "components/classes/Jmomen";
import moment from "moment-jalaali";
// ******************************************************************** writs ********************************************************************
const INDEX_MODIFIES_SUCCESS = "INDEX_MODIFIES_SUCCESS";
const SHOW_MODIFY_SUCCESS = "SHOW_MODIFY_SUCCESS";
const STORE_MODIFY_SUCCESS = "STORE_MODIFY_SUCCESS";
const STORE_WRIT_SUCCESS_Modifier = "STORE_WRIT_SUCCESS_Modifier";
const STORE_WRITE_MODIFY = "STORE_WRITE_MODIFY";
const UPDATE_MODIFY_SUCCESS = "UPDATE_MODIFY_SUCCESS";
const GET_MODIFY_STATE_DIAGRAM_SUCCESS = "GET_MODIFY_STATE_DIAGRAM_SUCCESS";
const STORE_CLOCKING_SUCCESS2 = "STORE_CLOCKING_SUCCESS2";
const UPDATE_CLOCKING_SUCCESS2 = "Update_CLOCKING_SUCCESS2";
const INDEX_ATTENDANCE_SALARY_CALCULATE_SUCCESS =
  "INDEX_ATTENDANCE_SALARY_CALCULATE_SUCCESS";
const INDEX_ATTENDANCE_Modifier_SUCCESS_CUSTOM =
  "INDEX_ATTENDANCE_Modifier_SUCCESS_CUSTOM";
const INDEX_ATTENDANCE_TOTAL_REPORT_SUCCESS =
  "INDEX_ATTENDANCE_TOTAL_REPORT_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ******************************************************************** writs ********************************************************************
/**
 *
 * @param {Array} payload
 * @return {{type: string, payload: *}}
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_MODIFIES_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {Object} payload
 * @return {{type: string, payload: *}}
 */
function _showSuccess(payload) {
  return {
    type: SHOW_MODIFY_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_MODIFY_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeCustomSuccess(payload) {
  return {
    type: STORE_WRITE_MODIFY,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeClockingSuccess(payload) {
  return {
    type: STORE_CLOCKING_SUCCESS2,
    payload: payload.data,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateClockingSuccess(payload) {
  return {
    type: UPDATE_CLOCKING_SUCCESS2,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeWritSuccess(payload) {
  return {
    type: STORE_WRIT_SUCCESS_Modifier,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_MODIFY_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _showModifierSuccess(payload) {
  return {
    type: INDEX_ATTENDANCE_SALARY_CALCULATE_SUCCESS,
    payload: payload, // payload OR {data: tables}
  };
}
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _showModifierSuccessCustom(payload) {
  return {
    type: INDEX_ATTENDANCE_Modifier_SUCCESS_CUSTOM,
    payload: payload, // payload OR {data: tables}
  };
}
// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

/**
 *
 * @param {Array} items
 * @return {Array} Edit Writs
 */
function getEditWrits(items) {
  let temp = [];

  items.map((item) => {
    temp.push(
      Object.assign({}, item, {
        className: item.deletedAt
          ? "record-deleted"
          : item.status
          ? `record-${item.status}`
          : "",
      })
    );
  });

  return temp;
}
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _showTotalReportSuccess(payload) {
  return {
    type: INDEX_ATTENDANCE_TOTAL_REPORT_SUCCESS,
    payload: payload, // payload OR {data: tables}
  };
}
// ******************************************************************** writs ********************************************************************
/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyWrits() {
  return _indexSuccess({ data: { writs: [] }, meta: {} });
}

/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyWrit() {
  return _showSuccess({ data: { writ: {} } });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyReport() {
  return _showModifierSuccess({ data: {} });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyRule() {
  return _showSuccess({ data: { rule: {} } });
}

/**
 * @param {Number} [id={}]
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function takeReport(id, data, callback = () => {}) {}
/**
 *
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {}

/**
 *
 * @param {Number} writs
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(writs, params = {}, callback = () => {}) {}
/**
 *
 * @param {Number} [id={}]
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showReport(id, data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    console.log("datadatdataa", data);
    if (app.can("Rule@getByCompanyCode")) {
      api
        .get(`SalaryReport/GetPersons?year=${data.year}&month=${data.month}`)
        .then((res) => {
          dispatch(_showModifierSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.attendance.rules",
            app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید"),
            app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Number} [id={}]
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showTotalReport(id, data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Rule@getByCompanyCode")) {
      api
        .post(`ta/EditReports/${id}/run`, { data })
        .then((res) => {
          dispatch(_showTotalReportSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.attendance.rules",
            "Rule",
            app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
          );
          callback(err);
        });
    }
  };
}
/**
 *
 * @param {Number} [id={}]
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeWritCustom(id, data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Rule@getByCompanyCode")) {
      api
        .post(`Ta/EditReports/${id}/Save`, { data })
        .then((res) => {
          dispatch(_storeCustomSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          // app.error(
          //   err,
          //   "routes.home.attendance.rules",
          //   "Rule",
          //   app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
          // );
          callback(err);
        });
    }
  };
}
/**
 *
 * @param {Number} [id={}]
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeSalaryReport(data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate("در حال ارسال اطلاعات"));

    api
      .post(`/SalaryReport/CreateSalaryReport`, { data })
      .then((res) => {
        dispatch(_storeCustomSuccess(res));
        callback(undefined, res);
        if (res.status === "درخواست با خطا مواجه شد") {
          loader.hide(() =>
            app.error(_, res.status, res.status, app.translate(res.status))
          );
        } else {
          loader.hide(() =>
            app.message(app.translate("اطلاعات با موفقیت ارسال شد"))
          );
        }
      })
      .catch((err) => {
        loader.hide(() =>
          app.error(
            err,
            "حذف شکست خورد",
            "حذف شکست خورد",
            app.translate("حذف شکست خورد")
          )
        );
      });
  };
}

/**
 *
 * @param {Number} [id={}]
 * @param {Object} [data={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeMonthlyManagerOpinion(id, data = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Rule@getByCompanyCode")) {
      api
        .post(`MonthlyManagerOpinion`, { data })
        .then((res) => {
          dispatch(_storeCustomSuccess(res));

          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.writs",
              "Writ",
              app.translate(
                "routes.home.attendance.writs.Adding New Writs Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Object} data
 * @param {string} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeWrit(data, acceptAll, callback = () => {}) {
  return async (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.writs.Adding New Writs")
    );
    let _path = "/ta/EditReports/Writs";

    if (acceptAll) {
      _path = `${_path}?acceptAll=true`;
    }

    api
      .post(_path, { data })
      .then(async (res) => {
        console.log("res123", res);
        const getValues = JSON.parse(localStorage.getItem("reportsValues"));
        console.log("getValues", getValues);
        await dispatch(_storeWritSuccess(res));
        dispatch(showReport(94, getValues));

        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.writs.New Writs Added Successfully"
            )
          )
        );
        showReport;
        callback(undefined, res.data);
      })
      .catch((err) => {
        loader.hide(() =>
          app.error(
            err,
            "routes.home.attendance.writs",
            "Writ",
            app.translate(
              "routes.home.attendance.writs.Adding New Writs Failed"
            )
          )
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Boolean} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeClocking(data, acceptAll, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.clocking.Adding New Clocking")
    );
    let _path = "/Ta/EditReports/Clockings";

    if (acceptAll) {
      _path = `${_path}?acceptAll=true`;
    }

    api
      .post(_path, { data })
      .then((res) => {
        dispatch(_storeClockingSuccess(res));
        // dispatch(showReport(94,{date_from: "2023-08-23",
        //   date_to: "2023-09-13",
        //   positions: [133],
        //   type: "default",
        //   year: "1402"
        // }))
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.clocking.New Clocking Added Successfully"
            )
          )
        );
        callback(undefined, res.data);
      })
      .catch((err) => {
        loader.hide(() =>
          app.error(
            err,
            "routes.home.attendance.clocking",
            "عملیات بروزرسانی با شکست مواجه شد!",
            app.translate(
              "routes.home.attendance.clocking.Adding New Clocking Failed"
            )
          )
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {Number} rulePack
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate("در حال ارسال اطلاعات"));

    api
      .delete(`/SalaryReport/CancelCalculateSalaryReport`, {
        data: data, // Pass the data in the body of the DELETE request
      })
      .then((r) => {
        // dispatch(_destroySuccess(rulePack));
        loader.hide(() => app.message(app.translate("حذف با موفقیت انجام شد")));
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "حذف شکست خورد",
            "حذف شکست خورد",
            app.translate("حذف شکست خورد")
          )
        );
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Boolean} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function updateClocking(data, acceptAll, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.clocking.Adding New Clocking")
    );
    let _path = "/Ta/EditReports/Clockings";

    if (acceptAll) {
      _path = `${_path}?acceptAll=true`;
    }
    api
      .put(_path, { data })
      .then((res) => {
        dispatch(_updateClockingSuccess(res));
        // dispatch(showReport(94,{date_from: "2023-08-23",
        //   date_to: "2023-09-13",
        //   positions: [133],
        //   type: "default",
        //   year: "1402"
        // }))
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.clocking.Clocking Updated Successfully"
            )
          )
        );
        callback(undefined, res.data);
      })
      .catch((err) => {
        loader.hide(() =>
          app.error(
            err,
            "routes.home.attendance.clocking",
            "عملیات بروزرسانی با شکست مواجه شد!",
            app.translate(
              "routes.home.attendance.clocking.Adding New Clocking Failed"
            )
          )
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {string} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, acceptAll, callback = () => {}, columnTitle) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.requests.Adding New Request")
    );
    api
      .post(`/requests${acceptAll}`, { data })
      .then((r) => {
        if (r.data.id || (r.data[0] && r.data[0].id)) {
          dispatch(_storeSuccess(r));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.requests.New Request Added Successfully"
              )
            )
          );
          callback();
        } else {
          loader.hide(() =>
            app.message(app.translate("routes.home.requests.Please check it"))
          );
          callback(r);
        }
      })
      .catch((e) => {
        loader.hide(() => {
          if (e.response && e.response.data) {
            callback(e.response.data, "store");
            return app.translate("routes.home.requests.Please check it");
          } else {
            return app.translate(
              "routes.home.requests.Adding New Request Failed"
            );
          }
        });
        // loader.hide(() => app.error(
        //   e, 'routes.home.requests.dashboard', 'Request',
        //   (() => {
        //     if (e.response && e.response.data) {
        //       callback(e.response.data, 'store');
        //       return app.translate('routes.home.requests.Please check it');
        //     } else {
        //       return app.translate('routes.home.requests.Adding New Request Failed');
        //     }
        //   })(),
        // ));
      });
  };
}
/**
 *
 * @param {Number} writs
 * @param {Object} data
 * @param {Boolean} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
/**
 *
 * @param {Number} request
 * @param {Object} data
 * @param {string} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(request, data, acceptAll, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.requests.Updating Request", "Updating Request")
    );
    api
      .put(`/requests/${request}${acceptAll}`, { data })
      .then((r) => {
        if (r.data.id) {
          dispatch(_updateSuccess(r));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.requests.Request Update Successfully",
                "Request Update Successfully"
              )
            )
          );
          callback(undefined, r);
        } else {
          loader.hide(() =>
            app.message(app.translate("routes.home.requests.Please check it"))
          );
          callback(r, "update");
        }
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.dashboard",
            "Request",
            (() => {
              if (e.response && e.response.data) {
                callback(e.response.data, "update");
                return app.translate("routes.home.requests.Please check it");
              } else {
                return app.translate(
                  "routes.home.requests.Updating Request Failed"
                );
              }
            })()
          )
        );
      });
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: object, payload: *}}
 */
function _showStateDiagramSuccess(payload) {
  return {
    type: GET_MODIFY_STATE_DIAGRAM_SUCCESS,
    payload: payload.data,
  };
}

/**
 * @param {Number} id
 * @param {function} callback
 * @return {Function}
 */
export function getStateDiagram(id, callback = (r) => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/requests/${id}/state_diagram`)
      .then((r) => {
        dispatch(_showStateDiagramSuccess(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @return {{type: object, payload: *}}
 */
export function emptyStateDiagram() {
  return _showStateDiagramSuccess({ data: { stateDiagram: [] } });
}

/**
 *
 * @param {Array} dataTable
 * @return {Array}
 */
export function getDataReport(dataTable) {
  let data = [];
  let rows;
  let row = {};
  let i = 0;
  [
    {
      person_id: 0,
      items: [
        {
          salary_item_id: 0,
          value: 0,
        },
      ],
    },
  ];
  if (!app._.isEmpty(dataTable) && !app._.isEmpty(dataTable.payload)) {
    dataTable.payload.map((table) => {
      console.log("tabletable", table);
      rows = [];
      table.body.map((_row, index) => {
        i++;
        // row = _row.payload;

        row = {
          ..._row.payload,
          details: _row?.details,
          clocking: _row?.clocking,
          getPositionId: table.props.user?.positions?.map((el) => el.id),
          typeId: table.props.user?.id,
          requests: _row?.requests,
          valueType: _row?.valueType,
          tooltip: _row?.tooltip,
          user_id: table?.props?.user?.id,
          checkboxItem: false,
          indexList: index,
        };
        row["props"] = [];
        row.key = i.toString();
        // row.valuesType = column.valuesType,
        row._props = _row.props;
        if (row._props && row._props.className && row._props.className !== "") {
          row.className = row._props.className;
        }
        rows.push(row);
      });
      table.footer.map((_row) => {
        i++;
        row = _row.payload;
        row["props"] = [];
        row.key = i.toString();
        row._props = Object.assign({}, _row.props, { type: "footer" });
        row.className = "reportTableFooter";
        rows.push(row);
      });

      data.push({ body: rows, props: table.props });
    });
  }

  return data;
}

/**
 *
 * @param {Array} dataTable
 * @return {Array}
 */
export function getColumns(dataTable) {
  let columns = [];
  let _column;
  let filter;
  let header = [];
  let openModal = false;
  const onAdd = () => {
    openModal = true;
  };
  if (!app._.isEmpty(dataTable)) {
    if (dataTable.header) {
      header = dataTable.header.payload;
      header.sort(function (_a, _b) {
        let a = parseInt(_a.priority ? _a.priority : 1);
        let b = parseInt(_b.priority ? _b.priority : 1);
        return a > b ? -1 : a < b ? 1 : 0;
      });
      app._.map(header, (column) => {
        console.log("columncolumc33olumnn", column);

        filter = null;
        if (column.filter) {
          filter = [];
          column.filter.filterable.map((_filter) => {
            filter.push({ text: _filter, value: _filter });
          });
        }
        _column = {};
        _column = {
          key: app._.camelCase(column.key),
          title: app.translate(
            `routes.home.attendance.reports.${column.value}`,
            `${column.value}`
          ),
          // sorter: column.sortable ? column.sortable : false,
          width: column.props && column.props.width ? column.props.width : 145,
          valuesType: column.valuesType,
          children: column.children,
          colSpan: column.colSpan,
          props: column.props,
          // filters: filter,
        };

        if (
          column.valuesType === "string" ||
          (column.valuesType !== "date" && column.valuesType !== "datetime")
        ) {
          // _column = Object.assign({}, _column, {
          //   render: (text, record) => {
          //     return _renderCel((text ? app.translate(`routes.home.attendance.reports.${text}`, `${text}`) : ''), record, column.key);
          //   },
          // });
          {
            _column = Object.assign({}, _column, {
              render: (text, row, index) => {
                if (column.value === "Personnel ID") {
                  return (
                    <a
                      onClick={() => onAdd([{}], false)}
                      style={{ color: "red", cursor: "pointer" }}
                    >
                      {text}
                    </a>
                  );
                } else {
                  return <div href="#">{text}</div>;
                }
              },
            });
          }
        } else {
          if (column.valuesType === "date") {
            _column = Object.assign({}, _column, {
              render: (text, record) => {
                return _renderCel(
                  text ? jMoment(text, "YYYY-M-D").format("jYYYY/jMM/jDD") : "",
                  record,
                  column.key
                );
              },
            });
          }
          if (column.valuesType === "datetime") {
            _column = Object.assign({}, _column, {
              render: (text, record) => {
                return _renderCel(
                  text
                    ? jMoment(text, "YYYY-M-D HH:mm:ss").format(
                        "HH:mm:ss jYYYY/jMM/jDD"
                      )
                    : "",
                  record,
                  column.key
                );
              },
            });
          }
        }

        // if()

        columns.push(_column);
      });
    }
  }
  return { columns, dataTable };
}

/**
 *
 * @param {Array} dataTable
 * @return {Array}
 */
export function getProperties(dataTable) {
  if (!app._.isEmpty(dataTable)) {
    return dataTable.props;
  }
  return {};
}
// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    writs: [],
    writ: {},
    meta: {},
    stateDiagram: [],
    rules: [],
    rule: {},
    dataReport: [],
    columns: [],
    properties: {},
    meta: {},
    newReports: [],
    metaNewReports: {},
    newReport: {},
  },
  action
) {
  let columns = [];
  let properties = [];
  let dataReport = [];
  switch (action.type) {
    case GET_MODIFY_STATE_DIAGRAM_SUCCESS:
      return Object.assign({}, state, {
        stateDiagram: action.payload.stateDiagram,
      });
    case STORE_CLOCKING_SUCCESS2:
      dataReport = app._.cloneDeep(state.dataReport);
      const dataReportClockingIndex = dataReport.findIndex((el) => {
        return el.props?.user?.id === action.payload?.userId;
      });
      const IndexClocking = dataReport[dataReportClockingIndex]?.body.findIndex(
        (el) => {
          return (
            el.date ===
              jMoment(action.payload.datetime, "YYYY-MM-DD").format(
                "YYYY-MM-DD"
              ) &&
            action.payload.userId ===
              dataReport[dataReportClockingIndex].props.user.id
          );
        }
      );
      dataReport[dataReportClockingIndex]?.body[IndexClocking].requests.push({
        typeId: 170,
        values: {
          date: jMoment(action.payload.datetime, "YYYY-MM-DD").format(
            "YYYY-MM-DD"
          ),
          time: moment(action.payload.datetime).format("HH:mm:ss"),
          clockingType: action.payload.entryType,
        },
      });

      return Object.assign({}, state, {
        dataReport,
      });
    case UPDATE_CLOCKING_SUCCESS2:
      dataReport = app._.cloneDeep(state.dataReport);
      const UpdateDataReportClockingIndex = dataReport.findIndex((el) => {
        return el.props?.user?.id === action.payload?.userId;
      });
      const UpdateIndexClocking = dataReport[
        UpdateDataReportClockingIndex
      ]?.body.findIndex((el) => {
        return (
          el.date ===
            jMoment(action.payload.datetime, "YYYY-MM-DD").format(
              "YYYY-MM-DD"
            ) &&
          action.payload.userId ===
            dataReport[UpdateDataReportClockingIndex].props.user.id
        );
      });
      dataReport[UpdateDataReportClockingIndex]?.body[
        UpdateIndexClocking
      ].requests.push({
        typeId: 170,
        values: {
          date: jMoment(action.payload.datetime, "YYYY-MM-DD").format(
            "YYYY-MM-DD"
          ),
          time: moment(action.payload.datetime).format("HH:mm:ss"),
          clockingType: action.payload.entryType,
        },
      });

      return Object.assign({}, state, {
        dataReport,
      });
    case STORE_MODIFY_SUCCESS:
      dataReport = app._.cloneDeep(state.dataReport);

      const dataReportIndex = dataReport.findIndex((el) => {
        return el.props?.user?.id === action.payload?.userId;
      });
      const IndexStore = dataReport[dataReportIndex]?.body.findIndex((el) => {
        if (!!action.payload?.values?.dateFrom) {
          return (
            el.date ===
              jMoment(action.payload.values.dateFrom, "YYYY-MM-DD").format(
                "YYYY-MM-DD"
              ) &&
            action.payload.userId === dataReport[dataReportIndex].props.user.id
          );
        } else {
          return (
            el.date ===
              jMoment(action.payload?.values?.date, "YYYY-MM-DD").format(
                "YYYY-MM-DD"
              ) &&
            action.payload.userId === dataReport[dataReportIndex].props.user.id
          );
        }
      });
      dataReport[dataReportIndex].body[IndexStore].requests.push(
        action.payload
      );

      return Object.assign({}, state, {
        dataReport,
      });
    case STORE_WRIT_SUCCESS_Modifier:
      dataReport = app._.cloneDeep(state.dataReport);
      const dataReportWritIndex = dataReport.findIndex((el) => {
        return el.props?.user?.id === action.payload?.userId;
      });

      const IndexWrite = dataReport[dataReportWritIndex]?.body.findIndex(
        (el) => {
          return (
            el.date ===
              jMoment(action.payload.dateFrom, "YYYY-MM-DD").format(
                "YYYY-MM-DD"
              ) &&
            action.payload.userId ===
              dataReport[dataReportWritIndex].props.user.id
          );
        }
      );
      dataReport[dataReportWritIndex]?.body[IndexWrite]?.requests.push(
        action.payload
      );

      return Object.assign({}, state, {
        dataReport,
      });

    case STORE_WRITE_MODIFY:
      dataReport = app._.cloneDeep(state.dataReport);
      return Object.assign({}, state, {
        dataReport,
      });

    case INDEX_ATTENDANCE_SALARY_CALCULATE_SUCCESS:
      columns = getColumns(action.payload.data);
      properties = getProperties(action.payload.data);
      dataReport = getDataReport(action.payload.data);

      return Object.assign({}, state, {
        dataReport,
        properties,
        columns,
      });
    case INDEX_ATTENDANCE_TOTAL_REPORT_SUCCESS:
      columns = getColumns(action.payload.data);
      properties = getProperties(action.payload.data);
      dataReport = getDataReport(action.payload.data);
      return Object.assign({}, state, {
        dataReport,
        properties,
        columns,
      });
    default:
      return state;
  }
}
